import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  sponsoredEvents: {
    matchList: [],
    currentPage: 1,
    totalPage: 1
  },
  clearSponserBets: false
};

const topSponsoredEventSlice = createSlice({
  name: "topSponsoredEvent",
  initialState,
  reducers: {
    getTopSponsoredEventStart: (state, action) => {
      state.loading = true;
    },
    getTopSponsoredEventSuccess: (state, action) => {
      const matches = action?.payload?.matchList?.map((match) => {
        const matchMarkets = {};
        const matchMarketIds = match?.matchMarkets?.map((market) => {
          matchMarkets[market?.matchMarketId] = market;
          return market?.matchMarketId;
        });
        return {
          ...match,
          matchMarkets,
          matchMarketIds
        };
      });

      state.loading = false;
      if (parseInt(action.payload?.currentPage) > 1) {
        state.sponsoredEvents?.matchList?.push(...matches);
      } else {
        state.sponsoredEvents = {
          matchList: matches,
          currentPage: parseInt(action.payload?.currentPage),
          totalPage: parseInt(action.payload?.totalPage)
        };
      }
    },
    getTopSponsoredEventFailure: (state, action) => {
      state.loading = false;
    },

    resetSponseredMatches: (state, action) => {
      state.sponsoredEvents = initialState.sponsoredEvents;
      state.loading = initialState.loading;
    },
    clearSponserBetOnMatchEnd: (state, action) => {
      state.clearSponserBets = action.payload;
    }
  }
});

export const {
  resetSponseredMatches,
  getTopSponsoredEventStart,
  getTopSponsoredEventSuccess,
  getTopSponsoredEventFailure,
  updateSponseredMatchesWithSocketData,
  clearSponserBetOnMatchEnd
} = topSponsoredEventSlice.actions;

export default topSponsoredEventSlice.reducer;
